import $ from 'jquery';

$(document).on("click", ".btn-add-voucher", function (e) {
    const button = $(this);
    const voucherId = button.data("voucher-id");
    const contentId = button.data("content-id");

    const quantity = String(button.siblings(".voucher-quantity").val() ?? "0");

    if (parseInt(quantity) === 0) {
        e.preventDefault();
        alert("Please select at least one voucher.");
        return;
    }

    // Optional: enforce max 4 vouchers per basket
    const currentBasketCount = $(".db-vouchers-basket .voucher-in-cart").length;
    if (currentBasketCount + parseInt(quantity) > 4) {
        e.preventDefault();
        $("#voucherLimitModal").modal("show");
        return;
    }

    // Update the button href with query string
    button.attr("href",
        `/Voucher/AddToBasket?contentId=${encodeURIComponent(contentId)}&voucherIds=${encodeURIComponent(voucherId)}&quantities=${encodeURIComponent(quantity)}`
    );
});